import { createUseStyles } from 'react-jss'

export default createUseStyles({
  icon: ({ isLoading }) => ({
    flexShrink: 0,
    width: '100% !important',
    marginBottom: '2px',
    marginRight: '10px',
    '--icon__primary__fill__color': 'var(--card__icon__loader_color)',
    '& path': {
      stroke: isLoading ? 'transparent' : 'var(--card_icon_color)'
    }
  }),
  contentWrapper: ({ pillIsLoading }) => ({
    display: pillIsLoading ? 'none' : 'flex',
    alignItems: 'center',
    flexDirection: 'column'
  }),
  button: ({ isMaxPillLength }) => isMaxPillLength ? { minWidth: '250px' } : { whiteSpace: 'nowrap' },
  text: {
    marginTop: '2px !important',
    lineHeight: '1.25'
  },
  title: {
    marginTop: '0 !important',
    fontFamily: 'BentonSansMedium'
  }
})
